import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { slide as Menu } from "react-burger-menu";
import arrowDown from '../images/arrowDown.svg';
import arrowRight from '../images/arrow-right.svg';

function AppBar({ scrolling = false, showPartnerButton = false, onPartnerClick = null }) {
  const navigate = useNavigate();
  const menuRef = useRef();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isMobile, setIsMobile] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [racesOpen, setRacesOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    const handleResizeMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResizeMobile();
    window.addEventListener("resize", handleResize);
    window.addEventListener("resize", handleResizeMobile);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("resize", handleResizeMobile);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  const handleMenuStateChange = (state) => {
    setMenuOpen(state.isOpen);
  };

  const handleNavigation = (section) => {
    // Navigate to dashboard and scroll to specific section
    navigate('/', { state: { scrollTo: section } });
  };

  const menuItems = (
    <ul className="nav-menu">
      <li className={`nav-item ${racesOpen ? "open" : ""}`}>
        <a
          className="nav-link"
          onClick={() => setRacesOpen((prev) => !prev)}
        >
          Races <img src={arrowDown}/>
        </a>
        <div className="dropdown-container">
          <button className="dropdown-btn" onClick={() => { handleNavigation("races"); setMenuOpen(false)}}>
            Upcoming Races <img style={{color: "white"}} src={arrowRight}/>
          </button>
          <button className="dropdown-btn" disabled onClick={() => navigate('/event/previous')}>
            Previous Races <img style={{color: "white"}} src={arrowRight}/>
          </button>
        </div>
      </li>
      <li className="nav-item">
        <a className="nav-link" onClick={() => { handleNavigation("why"); setMenuOpen(false); }}>
          Why Aquaman
        </a>
      </li>
      <li className="nav-item">
        <a className="nav-link" onClick={() => { handleNavigation("passport"); setMenuOpen(false); }}>
          Passport
        </a>
      </li>
      <li className="nav-item">
        <a className="nav-link" onClick={() => { handleNavigation("store"); setMenuOpen(false); }}>
          Shop
        </a>
      </li>
      <li className="nav-item">
        <a className="nav-link" onClick={() => { handleNavigation("blog"); setMenuOpen(false); }}>
          Connect
        </a>
      </li>
    </ul>
  );

  return (
    <div
      id="menu-wrap"
      className={`menu-back ${
        scrolling ? "fixed-navbar" : "cbp-af-header"
      }`}
      style={{
        backgroundColor: scrolling ? "#112348" : "transparent",
        boxShadow: scrolling ? "0 2px 8px rgba(0, 0, 0, 0.15)" : "none"
      }}
    >
      {screenWidth < 768 ? (
        <div>
          <div
            className="logo"
            onClick={() => handleNavigation("top")}
          >
            <a href="home"></a>
          </div>
          <Menu right isOpen={menuOpen} onStateChange={handleMenuStateChange}>
            {menuItems}
          </Menu>
        </div>
      ) : (
        <div className="container-appbar">
          <div className="twelve columns" style={{ marginTop: "1.5em" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div className="appbar-left">
                <div
                  className="logo"
                  onClick={() => handleNavigation("top")}
                >
                  <a href="home"></a>
                </div>
                <ul className="slimmenu">
                  <li
                    className="races-menu"
                    onMouseEnter={() => !isMobile && setRacesOpen(true)}
                    onMouseLeave={() => !isMobile && setRacesOpen(false)}
                  >
                    <a
                      onClick={() => {
                        if (isMobile) {
                          setRacesOpen((prev) => !prev);
                        }
                      }}
                    >
                      Races  <img src={arrowDown}/>
                    </a>
                    {racesOpen && (
                      <div className="dropdownMain">
                        <button
                          className="race-btn"
                          onClick={() => handleNavigation("races")}
                        >
                          Upcoming Races{" "}
                          <span className="right-arrow"><img style={{width: "8px"}} size="8px" src={arrowRight}/></span>
                        </button>
                        <button className="race-btn" disabled
                        onClick={() => {navigate('/event/previous')}}>
                          Previous Races{" "}
                          <span className="right-arrow"><img style={{width: "8px"}} size="8px" src={arrowRight}/></span>
                        </button>
                      </div>
                    )}
                  </li>
                  <li>
                    <a
                      onClick={() => {
                        handleNavigation("why");
                      }}
                    >
                      Why Aquaman
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => {
                        handleNavigation("passport");
                      }}
                    >
                      Passport
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => {
                        handleNavigation("store");
                      }}
                    >
                      Shop
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={() => {
                        handleNavigation("blog");
                      }}
                    >
                      Connect
                    </a>
                  </li>
                </ul>
              </div>
              {showPartnerButton && (
                <div 
                  className="main-button" 
                  onClick={onPartnerClick}
                  style={{ cursor: 'pointer' }}
                >
                  Become a Partner
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AppBar;
